module.exports = __webpack_public_path__ + "static/media/cost.2f480bb6.png";